import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import IRouteConfig, { AUTH_ROUTES, UNAUTH_ROUTES } from './routing';
import { PageRoutes } from './routing/paths';
import PrivateRoute from './routing/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth } from './redux/slices/auth/actions';
import { AppDispatch, RootState } from './redux/store';
import { fetchNotifications, addNotification } from './redux/slices/notification/actions';
import { io } from 'socket.io-client';
import { SocketNotification } from './redux/slices/notification/types';
import LocalStorageService, {LocalStorageKeys} from './services/localStorageService';

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const token = LocalStorageService.get<string>(LocalStorageKeys.ACCESS_TOKEN);

  useEffect(() => {
    const performCheckAuth = async () => {
      await dispatch(checkAuth());
      setIsCheckingAuth(false);
    };
    performCheckAuth();
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchNotifications());      
      const socket = io(process.env.REACT_APP_API_BASE_URL, {
        transports: ["websocket"],
        query: { platform: 'web' },
        auth: { token: token}
      });

      socket.on('connect', () => {
        console.log('Socket connected', socket.id);
      });

      socket.on('notification-superadmin-update', (data: SocketNotification) => {
        dispatch(addNotification(data.notifications));
      });

      socket.on('notification-subadmin-update', (data: SocketNotification) => {
        dispatch(addNotification(data.notifications));
      });

      socket.on('disconnect', () => {
        console.log('Socket disconnected');
      });

      return () => {
        socket.disconnect();
      };
    }
  }, [isAuthenticated, token, dispatch]);

  const renderRoutes = (routes: IRouteConfig[]) =>
    routes.map(({ routeProps, children }, index) => (
      <Route key={index} path={routeProps.path} element={routeProps.element}>
        {children && renderRoutes(children)}
      </Route>
    ));

  if (isCheckingAuth) {
    return null; // Or a loading spinner component
  }

  return (
    <Router>
      <ToastContainer />
      <Routes>
        {/* Redirect root */}
        <Route path="/" element={<Navigate to={PageRoutes.LOGIN} replace />} />

        {/* Auth Routes */}
        {AUTH_ROUTES.map(({ routeProps }, index) => (
          <Route key={index} path={routeProps.path} element={routeProps.element} />
        ))}

        {/* Un Auth Routes */}
        <Route path="/" element={<PrivateRoute />}>
          {renderRoutes(UNAUTH_ROUTES)}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;